import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=6c205052&scoped=true"
import script from "./SplitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c205052",
  null
  
)

export default component.exports